





























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
@Component({
    components: {}
})
export default class extends AbpBase {
    @Prop({ type: String, default: '' }) value: String;

    selectDateTypes: Array<string> = new Array<string>();

    onChange(e){
        //console.log(e);
        let val = '';

        if (e.length > 0) {
            val = e.join(',');
        }
        //console.log(val,typeof val);
        this.$emit('input',val);
        this.$emit('change',val);
    }
    @Watch("value")
    onValueChange(newVal,oldVal){
        //console.log('newVal:' + newVal +',oldVal:'+oldVal);
        if (!!newVal && newVal != oldVal) {
            this.selectDateTypes = newVal.split(',');
        } else {
            this.selectDateTypes = [];
        }
    }
}
